import { ExternalLink } from "lucide-react";
import Reveal from "@/components/Reveal";
import { ARTWORK } from "@/data/site";

export default function Artwork() {
  return (
    <div data-testid="artwork-page">
      <section className="parchment border-b border-[color:var(--accent)]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
          <Reveal>
            <div className="eyebrow mb-6">The Artwork · A gallery of paintings</div>
            <h1 className="font-display text-6xl md:text-8xl tracking-tighter leading-[0.92]">
              Painted at <span className="italic text-[color:var(--brg)]">Fuel Fed,</span>
              <br />signed with a smile.
            </h1>
          </Reveal>
          <Reveal delay={150}>
            <p className="mt-10 text-lg md:text-xl text-[color:var(--ink-secondary)] max-w-3xl leading-relaxed">
              A collection of watercolors and tributes made in honour of the cars — most by my friend, and actual Brit, <a href="https://richardsmyth.net" target="_blank" rel="noreferrer" className="italic underline decoration-[color:var(--brg)] underline-offset-4 hover:text-[color:var(--brg)]">Richard Smyth</a>, who learned to drive in the UK using a Herald.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-[color:var(--surface)]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 space-y-24 md:space-y-32">
          {ARTWORK.map((piece, idx) => (
            <Reveal key={piece.slug}>
              <article
                data-testid={`artwork-${piece.slug}`}
                className={`grid md:grid-cols-12 gap-10 md:gap-14 items-center ${idx % 2 === 1 ? "md:[&>div:first-child]:order-2" : ""}`}
              >
                <div className="md:col-span-7">
                  <a href={piece.image} target="_blank" rel="noreferrer" className="block group">
                    <div className="tile bg-[color:var(--bg)] p-4 md:p-8">
                      <img
                        src={piece.image}
                        alt={piece.title}
                        className="w-full h-auto object-contain max-h-[70vh] mx-auto"
                        loading="lazy"
                      />
                    </div>
                    <div className="mt-3 text-xs uppercase tracking-[0.22em] text-[color:var(--ink-muted)] text-right group-hover:text-[color:var(--brg)] transition inline-flex items-center gap-2 float-right">
                      View full size <ExternalLink size={12} />
                    </div>
                  </a>
                </div>
                <div className="md:col-span-5">
                  <div className="eyebrow mb-3">
                    No. {String(idx + 1).padStart(2, "0")} · {piece.subject}
                  </div>
                  <h2 className="font-display text-4xl md:text-5xl tracking-tight leading-[1.05] mb-4">
                    {piece.title}
                  </h2>
                  <div className="hairline mb-6 w-24"></div>
                  <div className="font-display italic text-2xl text-[color:var(--brg)]">
                    {piece.artist}
                    {piece.year && (
                      <span className="text-[color:var(--ink-muted)] not-italic font-body text-base ml-3 tracking-[0.15em] uppercase">
                        {piece.year}
                      </span>
                    )}
                  </div>
                  {piece.note && (
                    <p className="mt-6 text-base md:text-lg text-[color:var(--ink-secondary)] leading-relaxed">
                      {piece.note}
                    </p>
                  )}
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="parchment border-t border-[color:var(--accent)]">
        <div className="max-w-4xl mx-auto px-6 md:px-12 py-20 md:py-24 text-center">
          <Reveal>
            <div className="ornament text-3xl mb-6">✦</div>
            <p className="font-display italic text-2xl md:text-3xl text-[color:var(--ink-secondary)] leading-snug">
              Thanks to Richard Smyth for the paintings, and to every artist who has ever paused at a car show to sketch what they saw.
            </p>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
